import API from 'services/api';

export const restorePayment = ({ paymentId }: { paymentId: string }) => {
  return API.put(`api/accommodation/calculations/payments/${paymentId}/restore`);
};
